import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { RedirectGuard } from './core/auth/redirect.guard';
import { MainAdminComponent } from './features/admin/main-admin/main-admin.component';
import { MainGroupComponent } from './features/group/main-group/main-group.component';
import { MainPracticeComponent } from './features/practice/main-practice/main-practice.component';
import { GroupResolver } from './group.resolver';
import { PracticeResolver } from './practice.resolver';

const routes: Routes = [
    {
        path: 'admin',
        canActivate: [AuthGuard],
        component: MainAdminComponent,
        loadChildren: () => import('./features/admin/admin.module').then((m) => m.AdminModule),
    },
    {
        path: 'groups/:groupId',
        canActivate: [AuthGuard],
        component: MainGroupComponent,
        resolve: {
            group: GroupResolver,
        },
        loadChildren: () => import('./features/group/group.module').then((m) => m.GroupModule),
    },
    {
        path: 'practices/:practiceId',
        canActivate: [AuthGuard],
        component: MainPracticeComponent,
        resolve: {
            practice: PracticeResolver,
        },
        loadChildren: () => import('./features/practice/practice.module').then((m) => m.PracticeModule),
    },
    {
        path: 'onboarding',
        loadChildren: () => import('./features/onboarding/onboarding.module').then((m) => m.OnboardingModule),
    },
    { path: '**', children: [], canActivate: [AuthGuard, RedirectGuard] },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            paramsInheritanceStrategy: 'always',
            relativeLinkResolution: 'legacy',
            enableTracing: false,
        }),
    ],
    providers: [PracticeResolver, GroupResolver],
    exports: [RouterModule],
})
export class AppRoutingModule {}
